const Cart = {
  init: () => {
    Cart.events();
  },

  events: () => {
    let timeout;

    $("body").on("change", "input.qty", function () {
      let input = $(this);

      if (timeout !== undefined) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(function () {
        Cart.updateQuantity(input);
      }, 500);
    });

    $("body").on("click", ".cart-table__remove", function (e) {
      e.preventDefault();
      Cart.removeProduct($(this));
    });

    // Cart offer: add-to-cart button navigates to cart?apply=1&quantity=N (offer is inside main form, so no nested form)
    $("body").on("click", ".cart-offer__add-btn", function () {
      let form = $(this).closest(".cart-offer__form");
      let cartUrl = form.data("cart-url");
      let qtyInput = form.find(".cart-offer__qty-input");
      let qty = 1;
      if (qtyInput.length) {
        let val = parseInt(qtyInput.val(), 10);
        if (!isNaN(val) && val >= 1) {
          qty = Math.min(99, val);
        }
      }
      if (cartUrl) {
        let sep = cartUrl.indexOf("?") !== -1 ? "&" : "?";
        window.location = cartUrl + sep + "apply=1&quantity=" + qty;
      }
    });
  },

  removeProduct: (btn) => {
    $(".cab-cart").addClass("cab-cart--disabled");

    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "remove_from_cart",
        product_id: btn.data("id"),
        nonce: btn.data("nonce"),
      },
    }).always(() => {
      window.location.reload();
    });
  },

  updateQuantity: (input) => {
    let regex = /cart\[(.*?)\]\[qty\]/;
    let found = input.attr("name").match(regex);
    if (!found) {
      return
    }

    if (!found[1]) {
      return;
    }
    let item_key = found[1];
    let qty = input.val();

    $(".cab-cart").addClass("cab-cart--disabled");

    if(input.attr('data-change-done')) {
      input.removeAttr('data-change-done');
      return;
    }

    $.ajax({
      url: ajaxurl,
      type: "POST",
      dataType: "JSON",
      data: {
        action: "update_cart_item_quantity",
        item_key: item_key,
        qty: qty,
      },
    })
      .done((response) => {
        if (response.items) {
          let itemsRemoved = false;

          $(".woocommerce-cart-form tr[data-id]").each(function () {
            const key = $(this).data("id");
            if (!response.items[key]) {
              $(this).remove();
              itemsRemoved = true;
            }
          });

          if (itemsRemoved || !Object.keys(response.items).length) {
            window.location.reload();
            return;
          }

          let items = Object.keys(response.items);
          items.forEach((key) => {
            let data = response.items[key];
            const item = $(`.woocommerce-cart-form tr[data-id="${key}"]`);
            item.find(".cart-table__subtotal-col .price--subtotal").html(data.price);
            item.find(".qty").val(data.quantity);

            if (item.find(".cart-table__subtotal-col .price--sale").length) {
              item.find(".cart-table__subtotal-col .price--sale").html(data.regular_price);
            }
          });
        }

        if (response.vat_rates) {
          let vatRates = Object.keys(response.vat_rates);
          vatRates.forEach((key) => {
            $(`.cart-totals__item[data-id="${key}"] span`).html(
              response.vat_rates[key]
            );
          });
        }

        // Handle multiple fees
        if (response.fees && response.fees.length > 0) {
          // Remove all existing fee boxes
          $(".woocommerce-cart-form .fee-box").remove();

          // Add each fee separately
          response.fees.forEach((fee, index) => {
            if (fee.amount > 0.01) {
              const feeHtml = `
                <p class="cart-totals__item fee-box">
                  ${fee.name}:
                  <span class="cart-fee">${fee.formatted_amount}</span>
                </p>
              `;

              // Insert before the grand total
              $(".woocommerce-cart-form .cart-totals__item--grand-total").before(feeHtml);
            }
          });
        } else {
          $(".woocommerce-cart-form .fee-box").remove();
        }
        $(".woocommerce-cart-form .cart-total").html(response.total);
        $(".woocommerce-cart-form .cart-totals__item--discount span").html(response.discount);
        $(".woocommerce-cart-form .cart-totals__price").html(
          response.total_vat
        );

        // Update cart offer bars if cart_total_raw is available
        if (response.cart_total_raw !== undefined) {
          Cart.updateCartBars(parseFloat(response.cart_total_raw));
        }
      })
      .always(() => {
        $(".cab-cart").removeClass("cab-cart--disabled");
      });
  },

  updateCartBars: (cartTotal) => {
    // Update free shipping bar
    const freeShippingBar = $(".free-shipping-bar.cart-page-bar");
    if (freeShippingBar.length) {
      const threshold = parseFloat(freeShippingBar.data("threshold"));
      const message = freeShippingBar.data("message");
      const successMessage = freeShippingBar.data("success-message");

      const remainingAmount = threshold - cartTotal;
      const progressPercentage = Math.min(100, (cartTotal / threshold) * 100);

      if (remainingAmount > 0) {
        const remainingFormatted = remainingAmount.toFixed(2);
        const updatedMessage = message.replace("{amount}", ' <span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">\u20ac</span>' + remainingFormatted + '</bdi></span>');

        freeShippingBar.find(".free-shipping-bar__content").html(updatedMessage);

        if (freeShippingBar.find(".free-shipping-bar__progress").length === 0) {
          freeShippingBar.find(".free-shipping-bar__message").after(
            '<div class="free-shipping-bar__progress">' +
              '<div class="free-shipping-bar__progress-fill" style="width: ' + progressPercentage + '%;"></div>' +
            '</div>'
          );
        } else {
          freeShippingBar.find(".free-shipping-bar__progress-fill").css("width", progressPercentage + "%");
        }
      } else {
        freeShippingBar.find(".free-shipping-bar__content").html(successMessage);
        freeShippingBar.find(".free-shipping-bar__progress").remove();
      }
    }

    // Update small order fee bar ("add X to remove fee") when it exists – message only, no progress bar
    const feeBar = $(".cart-offer-bar--small-order-fee.cart-fee-bar.cart-page-bar");
    if (feeBar.length) {
      const feeThreshold = parseFloat(feeBar.data("threshold"));
      const feeRemaining = feeThreshold - cartTotal;
      if (feeRemaining > 0) {
        const feeRemainingFormatted = feeRemaining.toFixed(2);
        const feeAmountHtml = '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">€</span>' + feeRemainingFormatted + '</bdi></span>';
        const feeMessageTpl = feeBar.data("message") || (typeof translations !== "undefined" && translations.small_order_fee_message) || 'Lisa veel <strong>{amount}</strong> tooteid ostukorvi, et vabaneda väikese tellimuse töötlustasust.';
        feeBar.find(".cart-offer-bar__message").html(String(feeMessageTpl).replace("{amount}", feeAmountHtml));
      } else {
        // Crossed threshold; reload so page shows tier-1 bar and fee is removed
        window.location.reload();
        return;
      }
    }

    // Update cart offer bars (both tier 1 and tier 2)
    // Process tier 1 first, then tier 2
    const tier1Bar = $(".cart-offer-bar.cart-page-bar.cart-offer-bar--tier-1");
    const tier2Bar = $(".cart-offer-bar.cart-page-bar.cart-offer-bar--tier-2");

    let tier1Reached = false;
    let tier1Threshold = 0;

    // Update Tier 1 bar if it exists
    if (tier1Bar.length) {
      tier1Threshold = parseFloat(tier1Bar.data("threshold"));
      tier1Reached = cartTotal >= tier1Threshold;

      Cart.updateOfferBar(tier1Bar, cartTotal);
    }

    // Update Tier 2 bar if it exists
    // Tier 2 bar only appears when tier 1 is reached, so if tier 2 bar exists, tier 1 was already reached
    if (tier2Bar.length) {
      // If tier 1 bar doesn't exist but tier 2 does, tier 1 was already reached
      if (!tier1Bar.length) {
        tier1Reached = true;
      }

      // Only update tier 2 if tier 1 is reached
      if (tier1Reached) {
        Cart.updateOfferBar(tier2Bar, cartTotal);
      }
    }
  },

  updateOfferBar: (cartOfferBar, cartTotal) => {
    const tier = cartOfferBar.data("tier");
    const offerThreshold = parseFloat(cartOfferBar.data("threshold"));
    const productName = cartOfferBar.data("product-name");
    const offerPrice = parseFloat(cartOfferBar.data("offer-price"));
    const offerInfo = cartOfferBar.data("offer-info");
    const successMessage = cartOfferBar.data("success-message");

    // Ensure wasAboveThreshold is properly converted to boolean
    const wasAboveThresholdValue = cartOfferBar.data("was-above-threshold");
    const wasAboveThreshold = wasAboveThresholdValue === true || wasAboveThresholdValue === "true";
    const offerRemainingAmount = offerThreshold - cartTotal;
    const offerProgressPercentage = Math.min(100, (cartTotal / offerThreshold) * 100);

    if (offerRemainingAmount > 0) {
      // Below threshold

      // Check if we just went back below threshold (was above, now below)
      if (wasAboveThreshold) {
        // Crossed back down - reload page to remove offer product
        window.location.reload();
        return;
      }

      const offerRemainingFormatted = offerRemainingAmount.toFixed(2);
      const offerPriceFormatted = offerPrice.toFixed(2);

      // Get the message template from data attribute
      let offerMessageTemplate = cartOfferBar.data("progress-message") || (typeof translations !== "undefined" && translations.cart_offer_progress_message) || 'Lisa veel <strong>{remaining_amount}</strong>, et saada <strong>{product_name}</strong> hinnaga <strong>{offer_price}</strong>';

      // Replace placeholders with formatted values
      const offerMessage = offerMessageTemplate
        .replace('{remaining_amount}', '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">\u20ac</span>' + offerRemainingFormatted + '</bdi></span>')
        .replace('{product_name}', productName)
        .replace('{offer_price}', '<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">\u20ac</span>' + offerPriceFormatted + '</bdi></span>');

      cartOfferBar.find(".cart-offer-bar__message").html(offerMessage);

      if (offerInfo && cartOfferBar.find(".cart-offer-bar__info").length === 0) {
        cartOfferBar.find(".cart-offer-bar__message").after(
          '<div class="cart-offer-bar__info">' + offerInfo + '</div>'
        );
      }

      // Check if progress bar exists and add target if missing
      if (cartOfferBar.find(".cart-offer-bar__progress").length === 0) {
        const insertAfter = cartOfferBar.find(".cart-offer-bar__info").length
          ? cartOfferBar.find(".cart-offer-bar__info")
          : cartOfferBar.find(".cart-offer-bar__message");

        insertAfter.after(
          '<div class="cart-offer-bar__progress">' +
            '<div class="cart-offer-bar__progress-target">€' + Math.round(offerThreshold) + '</div>' +
            '<div class="cart-offer-bar__progress-fill" style="width: ' + offerProgressPercentage + '%;"></div>' +
          '</div>'
        );
      } else {
        cartOfferBar.find(".cart-offer-bar__progress-fill").css("width", offerProgressPercentage + "%");
      }

      cartOfferBar.removeClass("cart-offer-bar--success");
      cartOfferBar.find(".cart-offer-bar__message").removeClass("cart-offer-bar__message--success");
      cartOfferBar.data("was-above-threshold", false);
    } else {
      // Threshold reached or exceeded
      if (!wasAboveThreshold) {
        // First time crossing upward - reload page to add offer product
        window.location.reload();
        return;
      }

      cartOfferBar.addClass("cart-offer-bar--success");
      cartOfferBar.find(".cart-offer-bar__message")
        .addClass("cart-offer-bar__message--success")
        .html(successMessage);

      cartOfferBar.find(".cart-offer-bar__progress").remove();
      cartOfferBar.find(".cart-offer-bar__info").remove();
      cartOfferBar.data("was-above-threshold", true);
    }
  },
};
Cart.init();
